import React from 'react';
import styles from './SeasonGoal.module.sass';
import { timeConvert } from '../../../../../utils/utils.js';

export function SeasonGoal({ seasonGoalStats }) {
  const timeMet = seasonGoalStats.completedTime >= seasonGoalStats.seasonVideoGoal * 180;

  return (
    <div className={styles.seasonGoal}>
      <div className={styles.title}>
        <img
          className={styles.titleIcon}
          src={'/img/teams/AST_Season_Goal_icon.png'}
          alt="Season Goal"
        />
        SEASON GOAL
      </div>
      <div className={styles.counterContainer}>
        <div className={styles.counterContainerItem}>
          <div className={styles.counterTitle}>
            <div className={styles.margins}>GOAL</div>
          </div>
          <div>
            <div className={styles.counterClipsContainer}>
              <div className={styles.counterClip}></div>
              <div className={styles.counterClip}></div>
            </div>
            <div className={styles.counter}>
              <div className={styles.counterValue + ' ' + (timeMet ? styles.green : styles.red)}>
                {seasonGoalStats.seasonVideoGoal}
              </div>
              <div className={styles.counterValue + ' ' + (timeMet ? styles.green : styles.red)}>
                {timeConvert(seasonGoalStats.seasonVideoGoal * 180)}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.counterContainerItem}>
          <div className={styles.counterTitle}>
            <div className={styles.margins}>COMPLETED</div>
          </div>
          <div>
            <div className={styles.counterClipsContainer}>
              <div className={styles.counterClip}></div>
              <div className={styles.counterClip}></div>
            </div>
            <div className={styles.counter}>
              <div className={styles.counterValue + ' ' + (timeMet ? styles.green : styles.red)}>
                {seasonGoalStats.completedVideos}
              </div>
              <div className={styles.counterValue + ' ' + (timeMet ? styles.green : styles.red)}>
                {timeConvert(seasonGoalStats.completedTime)}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.counterContainerItem}>
          <div className={styles.counterTitle}>DAYS REMAINING</div>
          <div>
            <div className={styles.counterClipsContainer}>
              <div className={styles.counterClip}></div>
              <div className={styles.counterClip}></div>
            </div>
            <div className={styles.counter}>
              <div
                className={styles.counterSingleValue + ' ' + (timeMet ? styles.green : styles.red)}
              >
                {seasonGoalStats.daysRemaining > 0 ? seasonGoalStats.daysRemaining : 0} days
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
